
import { styled, Switch, SwitchProps } from "@mui/material";

interface IOSSwitchProps extends SwitchProps {
  width?: number;
  height?: number;
  thumbSize?: number;
  onColor?: string;
  offColor?: string;
  thumbColor?: string;
  disabledThumbColor?: string;
  focusThumbColor?: string;
}

const IOSSwitch = styled((props: IOSSwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(
  ({
    theme,
    width = 50,
    height = 24,
    thumbSize = 20,
    onColor = "#3a2ada",
    offColor = "#D3D3D3",
    thumbColor = "#fff",
    disabledThumbColor = theme.palette.grey[300],
    focusThumbColor = "#007BFF",
  }) => ({
    width,
    height,
    padding: 0,
    display: "flex",
    alignItems: "center",
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: `translateX(${width / 2}px)`,
        color: thumbColor,
        "& + .MuiSwitch-track": {
          backgroundColor: onColor,
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: focusThumbColor,
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: disabledThumbColor,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.7,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: thumbSize,
      height: thumbSize,
      position: "relative",
      
    },
    "& .MuiSwitch-track": {
      borderRadius: height / 2,
      backgroundColor: offColor,
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 300,
      }),
    },
  })
);

export default IOSSwitch;